module.exports = __webpack_public_path__ + "img/lens-167-minus-01.463959f9.png";